/* eslint-disable react/jsx-no-useless-fragment */
import React from 'react';
import Table from '../../Common/Table';
import NotificationService from '../../../Service/NotificationService';
import { GetFormat } from '../../../AppUtil/AppUtil';
import Swal from 'sweetalert2';
import Filter from './Filter';

export default class Notifications extends React.Component {
	constructor() {
		super();
		this.state = {
			_customFilterQuery: ''
		};
	}

	toastToShowMessage = html => {
		Swal.fire({
			html: html,
			width: '40%',
			showConfirmButton: false,
			// customClass: { content: 'alert-text' },

			customClass: 'otp_message_success'
		});
	};

	onResetFilter = () => {
		this.setState({
			_customFilterQuery: ''
		});
	};

	onSearch = obj => {
		let customFilterQuery = '';
		for (const key of Object.keys(obj)) {
			if (obj[key]) {
				customFilterQuery += `${key}=${obj[key]}&`;
			}
		}
		this.setState({
			_customFilterQuery: customFilterQuery
		});
	};

	setNotificationsDetail = async queryUrl => {
		return NotificationService.getLogs(this.props.match.params.id, queryUrl);
	};

	render() {
		const columns = [
			{
				name: 'type',
				label: 'Type'
			},
			{
				name: 'loan_id',
				label: 'Loan Id'
			},
			{
				name: 'title',
				label: 'Subject',
				options: {
					customBodyRender: value => {
						return value !== null ? `${value}` : 'N/A';
					}
				}
			},
			{
				name: 'content',
				label: 'Message',
				options: {
					customBodyRender: value => {
						if (value !== undefined) {
							return (
								<>
									<button
										className="btn btn-block btn-outline-primary btn-xs"
										onClick={() => {
											this.toastToShowMessage(value);
										}}
										type="button">
										Click to View
									</button>
								</>
							);
						}
					}
				}
			},
			{
				name: 'created_at',
				label: 'Creation Date',
				options: {
					customBodyRender: value => {
						return `${GetFormat(value)}`;
					}
				}
			}
		];

		return (
			<>
				<Filter onResetFilter={this.onResetFilter} onSearch={this.onSearch} />
				<Table
					columns={columns}
					customFilterQuery={this.state._customFilterQuery}
					dataSourceHandler={this.setNotificationsDetail}
					dataSourceName="notifications"
					title="Notifications"
				/>
			</>
		);
	}
}
